module.exports = new __parcel__URL__("list_view_panel.9947246c.png").toString();